export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9372.b48831a2.jpg";